<div class="details">
  <div class="row">
    <div class="col-md-6">
      <h5 class="hub-level-1-label">Strategies</h5>
      @if (relatedStrategies.length) {
        <div class="hub-pill-list">
          @for (relation of relatedStrategies; track trackByFn($index, relation)) {
            <span>
              <a [routerLink]="'/portfolio/' + relation.relatedProject?.projectId"
                class="badge-prio-strategy badge font-size-lg mr-1 mb-1">
                {{relation.relatedProject?.name}}
              </a>
            </span>
          }
        </div>
      }

      @if (!relatedStrategies.length) {
        <div class="no-relations-warning">
          This record does not have any relations to Strategies.
        </div>
      }

      <h5 class="hub-level-1-label">Projects</h5>

      @if (relatedProjects.length) {
        <div class="hub-pill-list">
          @for (relation of relatedProjects; track trackByFn($index, relation)) {
            <span>
              <a [routerLink]="'/portfolio/' + relation.relatedProject?.projectId"
                class="badge-prio-strategy badge font-size-lg mr-1 mb-1">
                {{relation.relatedProject?.name}}
              </a>
            </span>
          }
        </div>
      }

      @if (!relatedProjects.length) {
        <div class="no-relations-warning">
          This record does not have any relations to Projects.
        </div>
      }

      <h5 class="hub-level-1-label">Whole Systems</h5>

      @if (relatedWholeSystems.length) {
        <div class="hub-pill-list">
          @for (relation of relatedWholeSystems; track trackByFn($index, relation)) {
            <span>
              <a [routerLink]="'/portfolio/' + relation.relatedProjectId"
                class="badge-prio-strategy badge font-size-lg mr-1 mb-1">
                {{relation.relatedProject?.name}}
              </a>
            </span>
          }
        </div>
      }

      @if (!relatedWholeSystems.length) {
        <div class="no-relations-warning">
          This record does not have any relations to Whole Systems.
        </div>
      }

    </div>

    <div class="col-md-6">

      <h5 class="hub-level-1-label">Region(s)</h5>

      <ul class="hub-bulleted-list">
        @for (regionName of regionNames; track regionName) {
          <li>
            {{ regionName }}
          </li>
        }
      </ul>

      <h5 class="hub-level-1-label">Division(s)</h5>

      <ul class="hub-bulleted-list">
        @for (divisionName of divisionNames; track divisionName) {
          <li>
            {{ divisionName }}
          </li>
        }
      </ul>

      <h5 class="text-slate-600 font-weight-bold mt-2">Business Unit(s)</h5>

      <div class="hub-pill-list">
        @for (bu of projectBusinessUnits; track bu) {
          <span>
            @if (bu.isLeadBusinessUnit) {
              <a>
                <span
                class="badge badge-info font-size-lg mr-1 mb-1">{{ bu.businessUnit.name }}</span>
              </a>
            }
            @if (!bu.isLeadBusinessUnit) {
              <a>
                <span class="badge badge-info-secondary font-size-lg mr-1 mb-1">{{ bu.businessUnit.name }}</span>
              </a>
            }
          </span>
        }
      </div>

    </div>

  </div>
</div>
